import { CommitmentsPeriodsService_lifePeriodsVersionServiceGetRetirementPeriods } from '@festina/life-general-types/life/hooks/CommitmentsPeriodsService_lifePeriodsVersionServiceGetRetirementPeriods'

export const useFetchRetirementPeriods =
  CommitmentsPeriodsService_lifePeriodsVersionServiceGetRetirementPeriods.useSuspenseQuery
